<template>
  <div class="column flex-grow-0 fav-tabs">
    <ul class="columns is-multiline tabs">
      <li :class="tab == 'product' ? 'column is-12 is-active' : 'column is-12' ">
        <router-link :to="{ name: 'UserFavouriteProducts', params: { store_slug: this.$route.params.store_slug}, query: $route.query  }">
          <span class="tab-label">Products</span>
          <span class="quantity">{{ productCount }} </span>
        </router-link>
      </li>
      <li :class="tab == 'store' ? 'column is-12 is-active' : 'column is-12'">
        <router-link :to="{ name: 'UserFavouriteStores', params: { store_slug: this.$route.params.store_slug}, query: $route.query  }">
          <span class="tab-label">Stores</span>
          <span class="quantity">{{ storeCount }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'UserFavouriteTabs',
  data() {
    return {
    };
  },
  props: ['tab','productCount', 'storeCount'],
};
</script>

